
function InfosRecap2({ infos }) { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

    return (
        <div className="infos-recap2">
            <div className="infos-recap2-ligne-1">
                <p className="infos-recap2-ligne-titre">Liste des articles :</p>
            </div>

            <div className="infos-recap2-ligne-2">
                {infos.map((ligne, index) =>
                    <p key={index} className="infos-recap2-ligne-info">{ligne}</p>
                )}

            </div>



        </div>

    )
}




export default InfosRecap2